import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _FontAwesomeIcon;
import React from "react";
import { useState, useEffect, useCallback } from "react";
var styles = {
  "thumbnail": "pbui-TXRx2",
  "thumbnail--not-circle": "pbui-W1d0Q",
  "thumbnail--overlay": "pbui-emLgg",
  "thumbnail--overlay-top-right": "pbui-F9w2x",
  "clear--indicator": "pbui-L8Wlp",
  "overlay--button": "pbui-521eh",
  "dropzone-wrapper": "pbui-F493P",
  "dropzone": "pbui-6aD-l",
  "circle-wrapper": "pbui-CDGS-",
  "dropzone--disabled": "pbui-pyBPv",
  "dropzone--input": "pbui-E2E7m",
  "dropzone--underline": "pbui-CZhtm",
  "processed-files--wrapper": "pbui-9ykLc",
  "img-circle": "pbui-8owjk"
}; // React Dropzone
import { useDropzone } from "react-dropzone";
import clsx from "clsx";
import { editImage } from "./pintura";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function ImageEditor(_ref) {
  var children = _ref.children,
    isCircle = _ref.isCircle,
    width = _ref.width,
    height = _ref.height,
    disabled = _ref.disabled,
    multiple = _ref.multiple,
    store = _ref.store,
    editorConfig = _ref.editorConfig,
    token = _ref.token,
    initialImages = _ref.initialImages,
    onImageUpload = _ref.onImageUpload,
    uploadUrl = _ref.uploadUrl,
    onClearImage = _ref.onClearImage,
    clearIndicator = _ref.clearIndicator,
    _ref$clearIndicatorPo = _ref.clearIndicatorPosition,
    clearIndicatorPosition = _ref$clearIndicatorPo === void 0 ? 'center' : _ref$clearIndicatorPo,
    dropzoneClassName = _ref.dropzoneClassName;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    files = _useState2[0],
    setFiles = _useState2[1];
  var _useState3 = useState(function () {
      if (initialImages) {
        return initialImages;
      }
      return [];
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    processedFiles = _useState4[0],
    setProcessedFiles = _useState4[1];
  var _useDropzone = useDropzone({
      accept: {
        "image/*": []
      },
      multiple: multiple,
      onDrop: function onDrop(acceptedFiles) {
        setFiles(acceptedFiles.map(function (file) {
          return Object.assign(file, {
            preview: URL.createObjectURL(file)
          });
        }));
      }
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps;
  useEffect(function () {
    if (files && files.length > 0) {
      editImage(files[0], function (response) {
        if (onImageUpload) {
          onImageUpload(response);
        }
        if (response.pintura.store && response.pintura.store.uploadURL) {
          setProcessedFiles([].concat(_toConsumableArray(processedFiles), [response.pintura.store.uploadURL]));
        } else {
          setProcessedFiles([].concat(_toConsumableArray(processedFiles), [URL.createObjectURL(response.pintura.dest)]));
        }
      }, store, editorConfig, token, uploadUrl, isCircle);
    }
  }, [files, token, uploadUrl]);
  var derivedProcessedFiles = processedFiles || initialImages;
  var removeImage = useCallback(function (fileName) {
    setProcessedFiles(processedFiles.filter(function (item) {
      return item !== fileName;
    }));
  }, [processedFiles]);
  var thumbnailOverlayClasses = clsx(styles["thumbnail--overlay"], clearIndicatorPosition === 'top-right' && styles['thumbnail--overlay-top-right']);
  var thumbnailClasses = clsx(styles["thumbnail"], !isCircle && styles['thumbnail--not-circle']);
  var imgClasses = clsx(isCircle && styles["img-circle"]);
  var clearIndicatorClasses = clsx(clearIndicator ? styles["clear--indicator"] : styles["overlay--button"]);
  var thumbs = derivedProcessedFiles.map(function (file, index) {
    return /*#__PURE__*/_jsxs("div", {
      className: thumbnailClasses,
      children: [/*#__PURE__*/_jsx("div", {
        className: thumbnailOverlayClasses,
        children: /*#__PURE__*/_jsx("span", {
          className: clearIndicatorClasses,
          onClick: function onClick() {
            if (onClearImage) {
              onClearImage();
            }
            removeImage(file);
          },
          children: clearIndicator ? clearIndicator : _FontAwesomeIcon || (_FontAwesomeIcon = /*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: faTimes,
            size: "sm"
          }))
        })
      }), /*#__PURE__*/_jsx("img", {
        className: imgClasses,
        src: file,
        alt: ""
      })]
    }, index);
  });
  useEffect(function () {
    return function () {
      // Make sure to revoke the Object URL to avoid memory leaks
      processedFiles.forEach(function (file) {
        return URL.revokeObjectURL(file);
      });
    };
  }, [processedFiles]);
  useEffect(function () {
    return function () {
      // Make sure to revoke the Object URL to avoid memory leaks
      files.forEach(function (file) {
        return URL.revokeObjectURL(file.preview);
      });
    };
  }, [files]);
  var wrapperClasses = clsx(styles["dropzone-wrapper"]);
  var dropzoneClasses = clsx(styles.dropzone, dropzoneClassName, disabled && styles["dropzone--disabled"], isCircle && styles["circle-wrapper"]);
  var processedFileClasses = clsx(styles["processed-files--wrapper"]);
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperClasses,
    style: _extends({
      width: width,
      height: height
    }, isCircle ? {
      flexShrink: 0
    } : {}),
    children: [(multiple || !multiple && processedFiles.length === 0) && /*#__PURE__*/_jsxs("div", _extends({
      className: dropzoneClasses
    }, getRootProps(), {
      style: {
        height: height
      },
      children: [/*#__PURE__*/_jsx("input", _extends({}, getInputProps(), {
        className: styles["dropzone--input"]
      })), children ? children : /*#__PURE__*/_jsxs(_Fragment, {
        children: ["Drag and Drop your image or", /*#__PURE__*/_jsx("span", {
          className: styles["dropzone--underline "],
          children: "Browse"
        })]
      })]
    })), processedFiles.length > 0 && /*#__PURE__*/_jsx("div", {
      className: processedFileClasses,
      children: thumbs
    })]
  });
}